// src/context/HeaderContext.js
import { createContext, useContext, useState, useCallback } from "react";

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [screenName, setScreenName] = useState(null);
  const [refetchFns, setRefetchFns] = useState([]);
 
  const registerRefetch = useCallback((refetchFn) => {
    setRefetchFns((prev) => [...prev, refetchFn]);
  }, []);

  const triggerRefetches = () => {
    refetchFns.forEach((fn) => fn?.());
  };

  return (
    <HeaderContext.Provider
      value={{ screenName, setScreenName, registerRefetch, triggerRefetches }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => useContext(HeaderContext);
